import { ChatSummary } from "@/types/chat"
import { CollectionSummary } from "@/types/collection"
import { InspirationSummary } from "@/types/inspiration"
import { TripSummary } from "@/types/trip"

import { baseApi } from "./base-api"

export type RecentItem =
  | {
      type: "chat"
      chat: ChatSummary
    }
  | {
      type: "trip"
      trip: TripSummary
    }
  | {
      type: "saved_collection"
      saved_collection: CollectionSummary
    }
  | {
      type: "guide"
      guide: InspirationSummary
    }

export interface GetRecentItemsArgs {
  limit?: number
}

export interface GetRecentItemsResponse {
  items: RecentItem[]
}

export const recentItemsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRecentItems: builder.query<
      GetRecentItemsResponse,
      GetRecentItemsArgs | void
    >({
      query: (args) => {
        const params = new URLSearchParams()
        if (args?.limit) params.append("limit", args.limit.toString())

        const queryString = params.toString()
        return {
          url: queryString
            ? `/api/recent_items?${queryString}`
            : "/api/recent_items",
        }
      },
      providesTags: ["RecentItems"],
    }),
  }),
})

export const { useGetRecentItemsQuery } = recentItemsApi
